import axios from "axios";
import * as types from '../constants/ActionTypes'
import { toast } from 'react-toastify';

// Url's
// const updateUserInfoUrl = `${process.env.REACT_APP_API_URL}api/csa-app/update-consumer-detail`;
const updateUserInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/update-consumer-detail`;


// Actions
const updateUserInfoRequested = () => ({
  type: types.UPDATEUSERINFO_REQUEST
});

const updateUserInfoSuccess = data => ({
  type: types.UPDATEUSERINFO_SUCCESS,
  data
});

const updateUserInfoFailure = error => ({
  type: types.UPDATEUSERINFO_FAILURE,
  error
});


// API
export const updateUserInfo = ({ connection_id, user_data }) => {
  return dispatch => {
    dispatch(updateUserInfoRequested());
    axios.put(updateUserInfoUrl, {
      connection_id,
      mobile_no: user_data.cons_mobile_no,
      cons_first_name: user_data.cons_first_name,
      cons_last_name: user_data.cons_last_name,
      cons_email_id: user_data.cons_email_id,
      date_of_birth: user_data.cons_dob,
      cons_gender: user_data.cons_gender
    },
      {
        headers: {
          'Accept': 'application/json',
              'Content-Type': 'application/json'
          //'Content-Type': 'application/json; charset=UTF-8'
        }
      })
      .then(res => {
        if (res.data.ack === "Success") {
          setTimeout(() => {
            dispatch(updateUserInfoSuccess(res.data.status.message))
            toast.success(`User Profile Updated!`);
          },3000)
        } else if (res.data.ack === "Failure") {
          dispatch(updateUserInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


export const updateCsaUserInfo = (option) => {
  return dispatch => {
    dispatch(updateUserInfoRequested());
    axios.put(updateUserInfoUrl, option,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          //'Content-Type': 'application/json; charset=UTF-8'
        }
      })
      .then(res => {
        if (res.data.ack === "Success") {
          setTimeout(() => {
            dispatch(updateUserInfoSuccess(res.data.status.message))
            toast.success(`User Profile Updated!`);
          },3000)
        } else if (res.data.ack === "Failure") {
          dispatch(updateUserInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
